export default "__VITE_ASSET__D2HOkMUy__"